<template>
  <div>
    <label class="block text-sm font-medium text-gray-700 mb-2">{{ label }}</label>
    <div
      class="w-full flex flex-col items-center p-6 border border-dashed border-gray-200 rounded-xl hover:border-gray-300 transition-colors cursor-pointer"
      @click="$refs.fileInput.click()"
      @dragover.prevent
      @drop.prevent="handleDrop"
    >
      <div v-if="preview" class="mb-4 relative">
        <img 
          :src="preview" 
          alt="Logo preview" 
          class="max-h-12 w-auto object-contain"
        />
        <button
          type="button"
          class="absolute -top-2 -right-2 bg-gray-100 rounded-full p-1 hover:bg-gray-200"
          @click.stop="clearFile"
        >
          <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div class="text-sm text-gray-600">
        <span v-if="value">
          Selected: <span class="font-medium">{{ value.name }}</span>
        </span>
        <span v-else>
          Click to upload or drag and drop
        </span>
      </div>
    </div>
    <input 
      ref="fileInput"
      type="file" 
      :accept="accept" 
      @change="handleFileChange" 
      class="hidden"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: File,
    label: String,
    accept: String
  },

  data() {
    return {
      preview: null
    };
  },

  methods: {
    handleFileChange(e) {
      const file = e.target.files[0];
      this.processFile(file);
    },

    handleDrop(e) {
      const file = e.dataTransfer.files[0];
      this.processFile(file);
    },

    processFile(file) {
      this.$emit("input", file);
      if (file && file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.preview = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.preview = null;
      }
    },

    clearFile() {
      this.$emit("input", null);
      this.preview = null;
    }
  }
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}
</style>
